<template>
  <div>
    <div id="assignee-setting-container">
      <b-row>
        <b-col
          cols="5"
          class="p__l--5 p__r--5">
          <b-form-group>
            <j-single-select
              v-model="selectedType"
              :options="searchOptions"
              :placeholder="'Type'"
              value-format="object"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="7"
          class="p__l--5 p__r--5">
          <b-form-group>
            <j-input
              v-model="searchMember"
              placeholder="Search"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        class="assignee-list-vertical">
        <div
          v-for="(member, indexMember) in listMember"
          :key="indexMember"
          class="col-12 m__b--5 assignee-detail">
          <div class="checkbox assignee-outer">
            <label
              :for="member.id"
              class="row m__b--0 assignee-inner">
              <div
                class="assignee-add col-md-2 col-sm-3"
                style="text-align: center;padding-right: 0;">
                <img
                  v-if="getUserPhoto(member) !== '' && member.photo_url !== 'photo_url'"
                  :title="getUserEmail(member)"
                  :src="getUserPhoto(member)"
                  class="img-responsive card-assignee-photo-modal">
                <span
                  v-else
                  :title="getUserEmail(member)"
                  class="card-assignee-initial-modal add-card-assignee">
                  {{ getUserInitial(member) }}
                </span>
              </div>
              <div
                class="col-md-9 col-sm-7"
                style="padding-left: 0;">
                <div class="f--bold">{{ getUserName(member) }}</div>
                <div>{{ getUserTitle(member) }}</div>
              </div>
              <div class="col-md-1 col-sm-2">
                <span
                  class="assignee-remove"
                  @click="deleteBoardAssignee(member)">
                  <i class="fa fa-trash fa-2x"/>
                </span>
              </div>
            </label>
          </div><hr>
        </div>
      </b-row>
      <b-row
        class="assignee-add">
        <div class=" col-12 m__t--10 m__b--10 assignee-detail">
          <label
            class="row m__b--0 assignee-inner">
            <div class="col-3 pr-0">
              <span
                id="assigneeAdd"
                class="card-assignee-initial-modal add-card-assignee"
              >
                +
              </span>
            </div>
          </label>
        </div>
      </b-row>

      <b-popover
        ref="popoverAddBoardAssignee"
        :show.sync="popoverLabelUpdateShow"
        target="assigneeAdd"
        triggers="click"
        placement="auto"
        container="assignee-setting-container"
      >
        <h3>
          Add Member
        </h3>
        <b-form-group
          :class="{'error-input' : $v.newAssignee.$error}">
          <label for="assignee">New Member</label>
          <j-single-select
            id="assignee"
            v-model="newAssignee"
            :is-async="true"
            :load-options="loadUserOptions"
            :placeholder="'Select'"
            value-format="object"
            label="name"
          />
        </b-form-group>

        <b-button
          class="btn"
          @click="popoverLabelUpdateShow = false">
          Close
        </b-button>
        <b-button
          class="btn blue"
          @click="addBoardAssignee">
          Add
        </b-button>
      </b-popover>
    </div>

  </div>
</template>

<script>
import jMixBoard from '@/mixins/jMixBoard';
import jApiUser from '@/services/jApiUser';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';

export default {
  mixins: [
    jMixBoard,
  ],
  props: {
    boardId: {
      type: Number,
      default: () => null,
    },
    formId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      newAssignee: null,
      popoverLabelUpdateShow: false,
      listMember: [],
      searchMember: null,
      selectedType: {
        id: 0,
        text: 'Position',
        is_delete: false,
      },
      searchOptions: [
        {
          id: 0,
          text: 'Position',
          is_delete: false,
        },
        {
          id: 1,
          text: 'Employee',
          is_delete: false,
        },
      ],
    };
  },
  computed: {
    ...mapState('jStoreBoard', ['state_board']),
  },
  watch: {
    // eslint-disable-next-line
    'state_board.assignees': function (val) {
      this.listMember = this.state_board.assignees;
    },
    searchMember(val) {
      if (this.selectedType) {
        if (this.selectedType.id === 0) {
          this.listMember = this.state_board.assignees.filter((member) => {
            let position = '';
            if (member.organigrams) {
              position = member.organigrams[0].name;
            } else {
              position = member.title;
            }
            return position.toUpperCase().includes(val.toUpperCase());
          });
        } else {
          this.listMember = this.state_board.assignees.filter((member) => {
            const fullName = `${member.first_name} ${member.last_name}`;
            return fullName.toUpperCase().includes(val.toUpperCase());
          });
        }
      }
    },
  },
  created() {
    this.actionGetBoardAssignees(this.boardId);
  },
  methods: {
    ...mapActions('jStoreBoard', ['actionGetBoardAssignees', 'actionUpdateBoardAssignees']),

    loadUserOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: 'id',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.data = this.getListTags(reqData, callback);
      }
    },
    getListTags(req, callback) {
      return jApiUser.listUserPagination(req)
        .then((res) => {
          if (typeof res.data.data !== 'undefined') {
            res.data.data.forEach((lab, index) => {
              if (!lab.name.replace(/\s/g, '').length) {
                // eslint-disable-next-line
                res.data.data[index].label = lab.email;
              } else {
                // eslint-disable-next-line
                res.data.data[index].label = `${lab.email} - ${lab.name}`;
              }
            });
            callback(null, res.data.data);
          }
          return res.data;
        });
    },
    addBoardAssignee() {
      this.$v.newAssignee.$touch();
      if (!this.$v.newAssignee.$error) {
        const req = {
          board_id: this.boardId,
          form_id: this.formId,
          operation: 'add',
          user_company_id: this.newAssignee.id,
        };
        this.actionUpdateBoardAssignees(req).then((res) => {
          if (res.error) {
            this.$store.dispatch('jStoreNotificationScreen/toggleProblem', res.message);
          }
        });
        this.popoverLabelUpdateShow = false;
      }
    },
    deleteBoardAssignee(assignee) {
      if (assignee) {
        this.$swal({
          title: '<div style="color:#D2232A">Delete</div>',
          type: 'warning',
          html: `Are you sure to delete <span style="font-family: Poppins-Medium; font-size: 18px;">${assignee.first_name} ${assignee.last_name}</span>?`,
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#D2232A',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then((result) => {
          if (result.value) {
            const req = {
              board_id: this.boardId,
              operation: 'remove',
              form_id: this.formId,
              user_company_id: assignee.user_company_id,
            };
            this.actionUpdateBoardAssignees(req);
          }
        });
      }
    },
  },
  validations: {
    newAssignee: { required },
  },
};

</script>
<style lang="scss" scoped>
  .card-stage-container {
    background-color: #e7e9ed;
    padding: 20px 20px 15px 20px ;
    margin: 0 -20px 60px -20px;
    .stage-setting-container {
      overflow: auto;
      white-space: nowrap;
      .stage {
        display: inline-block;
        width: 209px;
        height: 160px;
        border-radius: 7px;
        box-shadow: 0 0 4px 0 rgba(154, 152, 152, 0.5);
        background-color: #f2f3f5;
        margin-bottom: 15px;
        .stage-content {
          display: table;
          height: 100%;
          width: 100%;
          position: relative;
          h4 {
            position: absolute;
            width: 100%;
            text-align: center;
          }
          .setting {
            width: 100%;
            display: table-row;
            text-align: center;
            vertical-align: middle;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/board/assignee/jBoardAssignee.vue